{
  "slug": "iq-percentiles",
  "title": "智商百分比表和解释",
  "description": "将常见得分转换为近似百分位数排名。",
  "category": "智商统计",
  "sections": [
    {
      "heading": "意义",
      "paragraphs": [
        "将常见得分转换为近似百分位数排名。",
        "解释取决于人口、仪器、版本、年份、抽样、语言和方法。"
      ]
    },
    {
      "heading": "仔细阅读图表",
      "paragraphs": [
        "检查代表性、不确定性、排除因素,以及值是否为测量值或估计值。",
        "群体平均值有很大重叠，无法确定一个人。"
      ]
    },
    {
      "heading": "负责任的结论",
      "paragraphs": [
        "首选透明的主要数据集和区间。 避免仅从相关性中提出因果关系。",
        "对于个人,使用适当的年龄规范和技术文档。"
      ]
    }
  ],
  "related": ["what-is-the-average-iq", "how-is-iq-measured", "iq-score-ranges-explained"],
  "sources": [
    {
      "label": "经合组织 — PISA数据和方法",
      "url": "https://www.oecd.org/pisa/data/"
    }
  ],
  "faqs": [],
  "summary": "将常见得分转换为近似百分位数排名。 18 七月 2026."
}
